//#region lib/Image/config.ts
var e = { maxSizeInMb: 50 };
//#endregion
export { e as CONFIG };
